import React from 'react';

import { BaseButton } from '@components/primitives';
import { SimpleCircleSpinner } from '@components/spinners';

import type { SubmitButtonProperties } from './SubmitButton.types';

export const SubmitButton: React.FC<SubmitButtonProperties> = ({
  dataTest = 'submit_button',
  isDisabled,
  color,
  form,
  isSubmitting,
  onClick,
  label,
  variant = 'contained',
  sx,
  size = 'large',
}) => {
  const handleClick = React.useCallback(() => {
    onClick?.();
  }, [onClick]);
  return (
    <BaseButton
      dataTest={dataTest}
      variant={variant}
      type='submit'
      color={color}
      disabled={isSubmitting || isDisabled}
      form={form}
      onClick={handleClick}
      size={size}
      startIcon={<SimpleCircleSpinner size='20' isLoading={isSubmitting} />}
      sx={{ width: '100%', ...sx }}
    >
      {isSubmitting
        ? (label ?? 'Отправляется...')
        : (label ?? 'Отправить')}
    </BaseButton>
  );
};
